export enum ClientStatus {
  unknown = 'unknown',
  active = 'active',
  deactivated = 'deactivated',
}
